import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { Gap, MyButton } from "../../atoms";
import LockIcon from "@mui/icons-material/Lock";
import LockOpenIcon from "@mui/icons-material/LockOpen";
import Tooltip from "@mui/material/Tooltip";
import { LOCAL_STORAGE_KEY } from "../../../config/API/config";
import ProfileTabs from "../ExcoPusat/ProfileTabs";
import { useDispatch } from "react-redux";
import { postLockUnlock } from "../../../config/Redux/ExcoDetailPusat/actions";
import { getExcoPusat } from "../../../config/Redux/ExcoPusat/actions";
import AlertMessage from "../../molecules/AlertMessage";

const DokumenPusat = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const dataExcoPusat = useSelector((state) => state.excopusat.dataExcoPusat);
  const data = dataExcoPusat?.data?.data?.[0];
  const isLocked = parseInt(data?.is_locked) === 1;
  const profile = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY));

  // Local state
  const [isLockActionLoading, setIsLockActionLoading] = React.useState(false);
  const [openAlert, setOpenAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");
  const [alertStatus, setAlertStatus] = React.useState(null);

  const checkHakAkses = (list, akses) => {
    let has = false;
    list?.map((val) => {
      if (val.hak_akses === akses) {
        has = true;
      }
      if (val.hak_akses === "Super Admin Semata") {
        has = true;
      }
      return val;
    });
    return has;
  };

  const handleLockUnlock = async () => {
    if (!data?.id_kantor_exco) {
      setAlertMessage("ID Kantor tidak ditemukan");
      setAlertStatus("error");
      setOpenAlert(true);
      return;
    }

    setIsLockActionLoading(true);
    try {
      const response = await dispatch(
        postLockUnlock({ id_kantor_exco: data.id_kantor_exco }),
      );

      if (response?.type?.includes("SUCCESS")) {
        const newStatus = isLocked ? "dibuka" : "dikunci";
        setAlertMessage(`Profil berhasil ${newStatus}`);
        setAlertStatus("success");
        setOpenAlert(true);
        // Refresh data after successful lock/unlock
        await dispatch(getExcoPusat());
      } else {
        setAlertMessage(
          response?.payload?.message || "Gagal mengubah status kunci",
        );
        setAlertStatus("error");
        setOpenAlert(true);
      }
    } catch (error) {
      setAlertMessage("Terjadi kesalahan saat mengubah status kunci");
      setAlertStatus("error");
      setOpenAlert(true);
    } finally {
      setIsLockActionLoading(false);
    }
  };

  useEffect(() => {
    dispatch(getExcoPusat());
  }, [dispatch]);

  const breadcrumbs = [
    <div
      onClick={() => navigate(-1)}
      style={{
        textDecoration: "none",
        fontWeight: "bold",
        color: "black",
        fontSize: "14px",
        cursor: "pointer",
      }}
      key="1"
    >
      EXCO Pusat
    </div>,
    <Typography
      key="2"
      color="text.primary"
      style={{ color: "#BDBDBD", fontSize: "14px", marginTop: "2px" }}
    >
      Dokumen SIPOL
    </Typography>,
  ];

  return (
    <div style={{ marginLeft: 20, marginRight: 20 }}>
      <AlertMessage
        openDialog={openAlert}
        message={alertMessage}
        status={alertStatus}
        handleCloseDialog={() => setOpenAlert(false)}
      />
      <Gap height={20} />
      <Breadcrumbs separator="›" aria-label="breadcrumb">
        {breadcrumbs}
      </Breadcrumbs>
      <Gap height={20} />
      <div
        style={{
          background: "white",
          paddingLeft: 16,
          paddingRight: 16,
          borderRadius: "20px",
          paddingTop: 8,
          paddingBottom: 20,
        }}
      >
        <p style={{ fontSize: 28, fontWeight: "bold", margin: "8px 0px" }}>
          EXCO Pusat - Dokumen SIPOL
          {isLocked ? (
            <Tooltip title="TERKUNCI, tidak dapat melakukan perubahan data">
              <LockIcon />
            </Tooltip>
          ) : null}
        </p>

        {checkHakAkses(profile?.data?.hak_akses, "Document Admin Access") ? (
          <div
            style={{
              marginBottom: 24,
              marginTop: 16,
              backgroundImage: `url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='8' ry='8' stroke='%23BDBDBD' stroke-width='1.5' stroke-dasharray='10%2c 10' stroke-dashoffset='0' stroke-linecap='square'/%3e%3c/svg%3e")`,
              borderRadius: "8px",
              padding: "16px",
            }}
          >
            {isLocked ? (
              // STATE: LOCKED -> Show "Terkunci" (Red)
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <MyButton
                  startIcon={<LockIcon />}
                  height="38px"
                  color="#D32F2F"
                  colorHover="#D32F2F"
                  fullWidth={true}
                  backgroundColor="#FFEBEE"
                  borderColor="#FFEBEE"
                  backgroundColorHover="#FFCDD2"
                  variant="contained"
                  children={isLockActionLoading ? "Loading..." : "Terkunci"}
                  onClick={isLockActionLoading ? null : handleLockUnlock}
                  style={{
                    borderRadius: "8px",
                    fontWeight: "bold",
                    fontSize: "14px",
                    textTransform: "none",
                    boxShadow: "none",
                  }}
                />
                <p
                  style={{
                    fontSize: "13px",
                    color: "#9E9E9E",
                    marginTop: "12px",
                    textAlign: "center",
                    margin: "12px 0 0 0",
                  }}
                >
                  Tidak dapat melakukan perubahan karna status terkunci. Klik
                  tombol diatas untuk membuka.
                </p>
              </div>
            ) : (
              // STATE: UNLOCKED -> Show "Tidak Terkunci" (Orange Outline)
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "100%",
                }}
              >
                <MyButton
                  startIcon={<LockOpenIcon />}
                  height="38px"
                  color="#F06524"
                  colorHover="#F06524"
                  fullWidth={true}
                  backgroundColor="#FFFFFF"
                  borderColor="#F06524"
                  backgroundColorHover="#FFF3E0"
                  variant="outlined"
                  children={
                    isLockActionLoading ? "Loading..." : "Tidak Terkunci"
                  }
                  onClick={isLockActionLoading ? null : handleLockUnlock}
                  style={{
                    borderRadius: "8px",
                    fontWeight: "bold",
                    fontSize: "14px",
                    textTransform: "none",
                    borderWidth: "1.5px",
                  }}
                />
                <p
                  style={{
                    fontSize: "13px",
                    color: "#9E9E9E",
                    marginTop: "12px",
                    textAlign: "center",
                    margin: "12px 0 0 0",
                  }}
                >
                  Anda dapat melakukan perubahan. Klik tombol untuk mengunci.
                </p>
              </div>
            )}
          </div>
        ) : null}
        <br />

        {/* ProfileTabs handles all tab content */}
        <ProfileTabs />

        <Gap height={10} />
      </div>
      <Gap height={100} />
    </div>
  );
};

export default DokumenPusat;
